import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
var ConfettiAnimation = function () {
    var containerRef = useRef(null);
    useEffect(function () {
        var colors = [
            '#ff6f61',
            '#6b5b95',
            '#88d8b0',
            '#ffcc5c',
            '#ff9a9e',
            '#feca57',
            '#3dc1d3', // Голубой
        ];
        var createConfetti = function () {
            var container = containerRef.current;
            if (!container)
                return;
            var _loop_1 = function (i) {
                var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                svg.setAttribute('viewBox', '0 0 100 100');
                svg.style.position = 'absolute';
                svg.style.top = '50%';
                svg.style.left = '50%';
                svg.style.transform = 'translate(-50%, -50%)';
                svg.style.width = "".concat(Math.random() * 15 + 10, "px"); // Увеличиваем размер
                svg.style.height = svg.style.width;
                var shapeType = Math.random() > 0.5 ? 'circle' : 'rect';
                var shape = void 0;
                if (shapeType === 'circle') {
                    shape = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
                    shape.setAttribute('cx', '50');
                    shape.setAttribute('cy', '50');
                    shape.setAttribute('r', '50');
                }
                else {
                    shape = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
                    shape.setAttribute('x', '0');
                    shape.setAttribute('y', '0');
                    shape.setAttribute('width', '100');
                    shape.setAttribute('height', '100');
                }
                shape.style.fill = colors[Math.floor(Math.random() * colors.length)];
                svg.appendChild(shape);
                var angle = Math.random() * 2 * Math.PI;
                var velocity = Math.random() * 200 + 100; // Увеличиваем скорость
                var animateX = document.createElementNS('http://www.w3.org/2000/svg', 'animate');
                animateX.setAttribute('attributeName', 'x');
                animateX.setAttribute('from', '0');
                animateX.setAttribute('to', "".concat(velocity * Math.cos(angle)));
                animateX.setAttribute('dur', '2s');
                animateX.setAttribute('repeatCount', '1');
                var animateY = document.createElementNS('http://www.w3.org/2000/svg', 'animate');
                animateY.setAttribute('attributeName', 'y');
                animateY.setAttribute('from', '0');
                animateY.setAttribute('to', "".concat(velocity * Math.sin(angle)));
                animateY.setAttribute('dur', '2s');
                animateY.setAttribute('repeatCount', '1');
                var animateOpacity = document.createElementNS('http://www.w3.org/2000/svg', 'animate');
                animateOpacity.setAttribute('attributeName', 'opacity');
                animateOpacity.setAttribute('from', '1');
                animateOpacity.setAttribute('to', '0');
                animateOpacity.setAttribute('dur', '2s');
                animateOpacity.setAttribute('repeatCount', '1');
                svg.appendChild(animateX);
                svg.appendChild(animateY);
                svg.appendChild(animateOpacity);
                container.appendChild(svg);
                // Удаляем элемент после завершения анимации
                setTimeout(function () { return svg.remove(); }, 2000);
            };
            for (var i = 0; i < 50; i++) {
                _loop_1(i);
            }
        };
        createConfetti();
    }, []);
    return (_jsx("div", { ref: containerRef, style: {
            position: 'relative',
            width: 320,
            height: 320,
            backgroundColor: '#1e1e2f',
            overflow: 'hidden'
        } }, void 0));
};
export default ConfettiAnimation;
